import React from "react";

const BookIcon = ({ color = "#FF7D1E" }) => {
  return (
    <svg
      width="18"
      height="15"
      viewBox="0 0 18 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.625 1.25C10.0497 1.25 9.58333 1.71637 9.58333 2.29167V13.9583C9.58333 14.3035 9.30351 14.5833 8.95833 14.5833C8.61316 14.5833 8.33333 14.3035 8.33333 13.9583V2.29167C8.33333 1.02601 9.35935 0 10.625 0H16.7917C17.413 0 17.9167 0.503679 17.9167 1.125V12.0536C17.9167 12.3987 17.6368 12.6786 17.2917 12.6786C16.9465 12.6786 16.6667 12.3987 16.6667 12.0536V1.25H10.625Z"
        fill={color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.29167 1.25C7.86696 1.25 8.33333 1.71637 8.33333 2.29167V13.9583C8.33333 14.3035 8.61316 14.5833 8.95833 14.5833C9.30351 14.5833 9.58333 14.3035 9.58333 13.9583V2.29167C9.58333 1.02601 8.55732 0 7.29167 0H1.125C0.50368 0 0 0.503679 0 1.125V12.0536C0 12.3987 0.279822 12.6786 0.625 12.6786C0.970178 12.6786 1.25 12.3987 1.25 12.0536V1.25H7.29167Z"
        fill={color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10 12.2917C10 11.9465 10.2798 11.6667 10.625 11.6667H17.2917C17.6368 11.6667 17.9167 11.9465 17.9167 12.2917C17.9167 12.6368 17.6368 12.9167 17.2917 12.9167H10.625C10.2798 12.9167 10 12.6368 10 12.2917Z"
        fill={color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.91667 12.2917C7.91667 11.9465 7.63684 11.6667 7.29167 11.6667H0.625C0.279822 11.6667 0 11.9465 0 12.2917C0 12.6368 0.279822 12.9167 0.625 12.9167H7.29167C7.63684 12.9167 7.91667 12.6368 7.91667 12.2917Z"
        fill={color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.25 12.2917C11.25 11.9465 10.9702 11.6667 10.625 11.6667C9.35935 11.6667 8.33333 12.6927 8.33333 13.9583C8.33333 14.3035 8.61316 14.5833 8.95833 14.5833C9.30351 14.5833 9.58333 14.3035 9.58333 13.9583C9.58333 13.383 10.0497 12.9167 10.625 12.9167C10.9702 12.9167 11.25 12.6368 11.25 12.2917Z"
        fill={color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.66667 12.2917C6.66667 11.9465 6.94649 11.6667 7.29167 11.6667C8.55732 11.6667 9.58333 12.6927 9.58333 13.9583C9.58333 14.3035 9.30351 14.5833 8.95833 14.5833C8.61316 14.5833 8.33333 14.3035 8.33333 13.9583C8.33333 13.383 7.86696 12.9167 7.29167 12.9167C6.94649 12.9167 6.66667 12.6368 6.66667 12.2917Z"
        fill={color}
      />
    </svg>
  );
};

export default BookIcon;
